import { Button, Divider, FormControlLabel, FormGroup, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { DOMESTIC_VIOLENCE, ELDER_ABUSE, PS_ABUSE_ADULT, SEXUAL_ABUSE } from '../../../store/abuseHistorySlice.slice';

interface TCodeOptionsProps {
    codeType: string;
    setPhysicalAbuseSelection: (selection: string) => void;
    physicalAbuseSelection: string;
    sexualAbuseSelection: string;
    setSexualAbuseSelection: (selection: string) => void;
    onClose: () => void;
    onSave: () => void;
}
const TCodeOptions = (props: TCodeOptionsProps) => {
    const { codeType, onClose, onSave, physicalAbuseSelection, setPhysicalAbuseSelection, sexualAbuseSelection, setSexualAbuseSelection } = props;
    return (
        <Stack spacing={2}>
            <Typography variant="h5">Please select appropriate code</Typography>
            <Divider />
            <FormGroup>
                <RadioGroup
                    row
                    value={codeType === SEXUAL_ABUSE ? sexualAbuseSelection : physicalAbuseSelection}
                    onChange={(e) => {
                        codeType === SEXUAL_ABUSE ? setSexualAbuseSelection(e.target.value) : setPhysicalAbuseSelection(e.target.value);
                    }}
                >
                    {(codeType === PS_ABUSE_ADULT || codeType === DOMESTIC_VIOLENCE || codeType === ELDER_ABUSE) && (
                        <>
                            <FormControlLabel
                                value={'T74.11XA|Adult physical abuse, confirmed, initial encounter'}
                                control={<Radio />}
                                label={'T74.11XA Adult physical abuse, confirmed, initial encounter'}
                            />
                            <FormControlLabel
                                value={'T74.11XD|Adult physical abuse, confirmed, subsequent encounter'}
                                control={<Radio />}
                                label={'T74.11XD Adult physical abuse, confirmed, subsequent encounter'}
                            />
                            <FormControlLabel
                                value={'T74.11XS|Adult physical abuse, confirmed, sequela'}
                                control={<Radio />}
                                label={'T74.11XS Adult physical abuse, confirmed, sequela'}
                            />
                            <FormControlLabel
                                value={'T76.11XA|Adult physical abuse, suspected, initial encounter'}
                                control={<Radio />}
                                label={'T76.11XA Adult physical abuse, suspected, initial encounter'}
                            />
                            <FormControlLabel
                                value={'T76.11XD|Adult physical abuse, suspected, subsequent encounter'}
                                control={<Radio />}
                                label={'T76.11XD Adult physical abuse, suspected, subsequent encounter'}
                            />
                            <FormControlLabel
                                value={'T76.11XS|Adult physical abuse, suspected, sequela'}
                                control={<Radio />}
                                label={'T76.11XS Adult physical abuse, suspected, sequela'}
                            />
                        </>
                    )}
                    {codeType === SEXUAL_ABUSE && (
                        <>
                            <FormControlLabel
                                value={'T76.21XA|Adult sexual abuse, suspected, initial encounter'}
                                control={<Radio />}
                                label={'T76.21XA Adult sexual abuse, suspected, initial encounter'}
                            />
                            <FormControlLabel
                                value={'T76.21XD|Adult sexual abuse, suspected, subsequent encounter'}
                                control={<Radio />}
                                label={'T76.21XD Adult sexual abuse, suspected, subsequent encounter'}
                            />
                            <FormControlLabel
                                value={'T76.21XS|Adult sexual abuse, suspected, sequela'}
                                control={<Radio />}
                                label={'T76.21XS Adult sexual abuse, suspected, sequela'}
                            />
                            <FormControlLabel
                                value={'T74.21XA|Adult sexual abuse, confirmed, initial encounter'}
                                control={<Radio />}
                                label={'T74.21XA Adult sexual abuse, confirmed, initial encounter'}
                            />
                            <FormControlLabel
                                value={'T74.21XD|Adult sexual abuse, confirmed, subsequent encounter'}
                                control={<Radio />}
                                label={'T74.21XD Adult sexual abuse, confirmed, subsequent encounter'}
                            />
                            <FormControlLabel
                                value={'T74.21XS|Adult sexual abuse, confirmed, sequela'}
                                control={<Radio />}
                                label={'T74.21XS Adult sexual abuse, confirmed, sequela'}
                            />
                        </>
                    )}
                </RadioGroup>
            </FormGroup>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button variant="outlined" color="primary" sx={{ minWidth: '120px' }} onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    disabled={physicalAbuseSelection === '' && sexualAbuseSelection === ''}
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: '120px' }}
                    onClick={onSave}
                >
                    Ok
                </Button>
            </Stack>
        </Stack>
    );
};

export default TCodeOptions;
